export type Nullable<T> = T | null | undefined;

export type Entries<T, K> = (o: { [k: string]: K }) => Array<[T, K]>;

type ObjectKeyType = string | number | symbol;

export type Diff<T extends ObjectKeyType, U extends ObjectKeyType> = ({ [P in T]: P } & { [P in U]: never } & {
    [x: string]: never;
})[T];

export type Override<T, U> = Pick<T, Diff<keyof T, keyof U>> & U;

export const isBrowser = typeof window !== "undefined";

const platform = ((isBrowser && navigator && navigator.platform) || "").toLowerCase();

export const isMac = platform.includes("mac");
